<template>

  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="6">
        <v-card>
          <v-data-table :headers="headers" :items="menus"
                        :items-per-page="5" :loading="loading" :search="search"
                        item-key="_id" show-expand show-select single-select>
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  Menus
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    hide-details
                    label="Search Menu"
                    single-line
                ></v-text-field>
                <v-spacer></v-spacer>

                <v-dialog v-model="dialogMenus" persistent>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="mb-2" color="primary">New Menu</v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark>
                      <v-btn
                          dark
                          icon
                          @click="closeMenus"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitleM }}</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn
                            :disabled="$v.$invalid"
                            dark
                            text
                            @click="saveMenus"
                        >
                          Save
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>

                    <v-row>
                      <v-col cols="6">
                        <Loader :loading="loadingCreateUpdateDelete"/>
                        <v-list subheader three-line>
                          <v-subheader>Menu Data</v-subheader>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>Menu Status</v-list-item-title>

                              <v-switch v-model="editedItemMenus.menu_status"
                                        :label="`State: ${editedItemMenus.menu_status ? 'Active' : 'Deactivated'}`">
                              </v-switch>
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>Menu Name</v-list-item-title>

                              <div>
                                <v-text-field v-model="editedItemMenus.menu_name" class="mt-2"
                                              label="Name"></v-text-field>
                                <p v-if="$v.editedItemMenus.menu_name.$model === '' && !$v.editedItemMenus.menu_name.required"
                                   style="color: red;">Please provide a valid name.</p>
                              </div>

                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>Menu Description</v-list-item-title>

                              <div>
                                <v-textarea v-model="editedItemMenus.menu_description" auto-grow
                                            class="mt-4" label="Description"
                                            outlined
                                            rows="2"></v-textarea>
                                <p v-if="$v.editedItemMenus.menu_description.$model === '' && !$v.editedItemMenus.menu_description.required"
                                   style="color: red;">Please provide a valid description.</p>
                              </div>

                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                      <v-col cols="6">
                        <menu-products v-if="editedIndexMenus !== -1"
                                       :categories_list="categories"
                                       :editing-mode="true"
                                       :products_list="products"
                                       :sel-menu="editedItemMenus"
                                       @update-menu="setMenu($event)"></menu-products>
                        <v-list v-else subheader three-line>


                          <v-list-item>

                            <v-list-item-content>
                              <v-list-item-title>Products</v-list-item-title>
                              <v-list-item-action>
                                <v-text-field
                                    v-model="searchNewMenu"
                                    append-icon="search"
                                    hide-details
                                    label="Search Product"
                                    single-line
                                ></v-text-field>
                              </v-list-item-action>

                              <v-data-table v-model="editedItemMenus.menu_products"
                                            :headers="headerSelectProducts"
                                            :items="products"
                                            :search="searchNewMenu"
                                            item-key="_id"
                                            show-select
                                            single-expand>
                              </v-data-table>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>

                    <v-divider></v-divider>

                  </v-card>

                </v-dialog>

                <v-dialog v-model="dialogDeleteMenus" max-width="590px" persistent>
                  <v-card>
                    <v-card-title class="headline">Are you sure you want to remove this menu?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDeleteMenus">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirmMenus">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                  <Loader :loading="loadingCreateUpdateDelete"/>
                </v-dialog>
              </v-toolbar>
            </template>


            <template v-slot:[`item.menu_status`]="{ item }">
              <v-simple-checkbox
                  v-model="item.menu_status"
                  @input="updateMenuStatus(item)"
              ></v-simple-checkbox>
            </template>

            <template v-slot:[`item.actions`]="{ item}">

              <v-btn
                  class="ml-1"
                  icon
                  x-small
                  @click="editItemMenus(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>


              <v-btn
                  class="ml-1"
                  icon
                  x-small
                  @click="deleteItemMenus(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.data-table-select`]="{ item,  isSelected, select}">
              <v-btn
                  class="ml-1"
                  icon
                  x-small
                  @click="updateSelection(item, select, isSelected)"
              >
                <v-icon v-if="!isSelected" @click="isSelected = !isSelected">mdi-eye-off</v-icon>
                <v-icon v-else @click="isSelected = !isSelected">mdi-eye</v-icon>
              </v-btn>


            </template>
            <template v-slot:expanded-item="{ headers, item }" class="mr-1">
              <td :colspan="headers.length">
                <p>
                  {{ item.menu_description }}
                </p>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

      <!--
        Alerts & Loaders
      -->
      <!--<Alerts :aType.sync="response"/>-->
      <Loader :loading="loadingCreateUpdateDelete"/>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-card v-if="selectedMenu" class="ml-2" fluid>

          <menu-products :editing-mode="false"
                         :sel-menu="selectedMenu"
                         @update-menu="setMenu($event)"></menu-products>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {
  manager_create_menu,
  manager_get_all_menus,
  manager_get_all_products,
  manager_get_categories,
  manager_update_menu,
  manager_delete_menu,
  manager_update_menu_status
} from "../../modules/nite_api";
import _ from "underscore";
import ProductsMenuComponent from '../shared/ProductsMenuComponent'
import Loader from "../shared/Loader"
import VueNotifications from "vue-notifications";


import {required} from 'vuelidate/lib/validators';

export default {
  name: "Menus",

  components: {
    "menu-products": ProductsMenuComponent,
    Loader

  },
  data() {
    return {
      response: null,

      loading: false,
      loadingCreateUpdateDelete: false,

      dialogMenus: false,
      dialogDeleteMenus: false,


      selectedMenu: null,

      editedIndexMenus: -1,


      editedItemMenus: {
        _id: '',
        menu_name: '',
        menu_status: false,
        menu_description: '',
        menu_products: []
      },
      defaultItemMenus: {
        _id: '',
        menu_name: '',
        menu_status: false,
        menu_description: '',
        menu_products: []
      },
      search: '',
      searchNewMenu: '',
      searchProducts: '',
      headers: [
        {text: 'Selection', value: 'data-table-select'},
        {
          text: 'Active',
          sortable: false,
          value: 'menu_status'
        },
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'menu_name'
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions'
        },
        {text: 'Description', value: 'data-table-expand'},

      ],

      headerSelectProducts: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'product_name'
        },
        {
          text: 'Category',
          sortable: true,
          value: 'product_category'
        },
        {
          text: 'Price (€)',
          sortable: true,
          value: 'product_price'
        }
      ],
      menus: [],
      products: [],
      categories: []

    }
  },
  validations: {
    editedItemMenus: {
      menu_name: {
        required
      },
      menu_status: {
        required,
        check: value => value === true || value === false
      },
      menu_description: {
        required
      }
    }
  },
  created() {
    this.getDataFromApi()
  },
  methods: {
    async getDataFromApi() {
      this.loading = true
      try {
        let [u1, u2, u3] = await Promise.all([
          manager_get_all_products(),
          manager_get_categories(),
          manager_get_all_menus()
        ]);
        // Success
        this.products = u1.data;
        this.categories = u2.data;
        this.menus = u3.data;
        this.loading = false;
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loading = false;
        switch (this.response) {
          case 200:

            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;

          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
    },
    async updateMenuStatus(item) {
      this.loadingCreateUpdateDelete = true;
      try {

        const response = await manager_update_menu_status(item._id);


        this.response = response.status;

        // Success
        console.log(response);
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:

            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;

          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
      await this.getDataFromApi();
    },
    updateSelection(selected_menu, select_func, select_status) {

      if (select_status)
        this.selectedMenu = selected_menu;
      else
        this.selectedMenu = null;
      select_func(select_status)
    },
    editItemMenus(item) {

      this.editedIndexMenus = this.menus.indexOf(item)
      this.editedItemMenus = {
        _id: item._id,
        menu_name: item.menu_name,
        menu_status: item.menu_status,
        menu_description: item.menu_description,
        menu_products: item.menu_products
      };
      this.dialogMenus = true
    },
    deleteItemMenus(item) {
      this.editedIndexMenus = this.menus.indexOf(item)
      this.editedItemMenus = Object.assign({}, item)
      this.dialogDeleteMenus = true
    },
    async deleteItemConfirmMenus() {

      this.loadingCreateUpdateDelete = true;
      try {

        const response = await manager_delete_menu(this.editedItemMenus._id);


        this.response = response.status
        // Success
        console.log(response);
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({
              title: 'Success',
              message: 'Menu deleted successfully'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The menu doesn\'t exist! Please try again!'});
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
      this.closeDeleteMenus()
    },
    closeMenus() {
      this.dialogMenus = false
      this.$nextTick(() => {
        this.editedItemMenus = Object.assign({}, this.defaultItemMenus)
        this.editedIndexMenus = -1
      })
      this.getDataFromApi();
    },
    closeDeleteMenus() {
      this.dialogDeleteMenus = false
      this.$nextTick(() => {
        this.editedItemMenus = Object.assign({}, this.defaultItemMenus)
        this.editedIndexMenus = -1
      })
      this.getDataFromApi();
    },
    async saveMenus() {

      let request_data = this.editedItemMenus;
      delete request_data['__v'];
      this.loadingCreateUpdateDelete = true;
      if (this.editedIndexMenus > -1) {
        try {
          let menu_id = this.editedItemMenus._id;
          delete request_data._id;

          const response = await manager_update_menu(menu_id, request_data);


          this.response = response.status

          // Success
          console.log(response);
        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Menu edited successfully!'});
              break;
            case 304:
              this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
              break;
            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }
      } else {
        delete request_data._id;
        request_data.menu_products.map((product) => {
          product['product_id'] = product['_id'];
          delete product['_id'];
          delete product['__v']
        })
        try {

          const response = await manager_create_menu(request_data)

          this.response = response.status

          // Success
          console.log(response);
        } catch (error) {
          // Error
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            console.log(error.response.data);
            console.log(error.response.status);
            this.response = error.response.status;

            console.log(error.response.headers);
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
          } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        } finally {
          this.loadingCreateUpdateDelete = false;
          switch (this.response) {
            case 200:
              this.showSuccessMsg({title: 'Success', message: 'Menu added successfully!'});
              break;

            case 400:
              this.showErrorMsg({
                title: 'Oops',
                message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
              });
              break;
            case 401:
              this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
              break;
            case 500:
              this.showErrorMsg({
                title: 'Error',
                message: 'Something went wrong with the request. Please try again later!'
              });
              break;
            default:
              break;
          }

        }
      }
      this.closeMenus()
    },
    setMenu(menu_products) {
      this.editedItemMenus.menu_products = menu_products.map((product) => _.clone(product));
    },
  },
  computed: {
    formTitleM() {
      return this.editedIndexMenus === -1 ? 'New Menu' : 'Edit Menu'
    },
  },
  watch: {
    dialogMenus(val) {
      val || this.closeMenus()
    },
    dialogDeleteMenus(val) {
      val || this.closeDeleteMenus()
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
  }
}
</script>


<style scoped>

</style>
